import React from "react";
import SEO from "@/components/SEO";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import NewsAndArticlesIndex from "@/components/NewsAndArticlesIndex";

const NewsAndArticlesPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEO title="News and Articles | Y3 Smiles Dental" description="Educational dental articles, guides, and local resources from Y3 Smiles Dental in Broadmeadows." image="/og-reception.jpg" />
      <Header />
      <main className="flex-grow">
        <NewsAndArticlesIndex />
      </main>
      <Footer />
    </div>
  );
};

export default NewsAndArticlesPage;
